import http from "./HttpService";

import { API_BASE_CONTENT } from "../../constants/index";
import { getCSRFToken } from "utils";
// import { getVersionId } from "modules/EmailBrowser/utils";

export function getFavoriteNewsService(limit: number, offset: number, emailId: number) {
  return http.get(`${API_BASE_CONTENT}favourite_articles/?limit=${limit}&offset=${offset}${emailId && emailId !== 0 ? `&version_id=${emailId}` : ""}`, {
    headers: { "X-CSRFToken": getCSRFToken() },
  });
  //* Remove the above code and uncomment the below code after API is updated
  // const versionId = getVersionId();
  // return http.get(
  //   `${API_BASE_CONTENT}favourite_articles/?version_id=${versionId}limit=${limit}&offset=${offset}`,
  //   { headers: { "X-CSRFToken": getCSRFToken() } }
  // );
}

export function removeFavoriteArticleService(id: Number) {
  var data = new FormData();
  data.append("article_id", id.toString());
  /* need to update it with the actual api  */
  return http.post(API_BASE_CONTENT + "delete_favorite_article/", data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}

export function addFavoriteArticleService(id: Number) {
  var data = new FormData();
  data.append("article_id", id.toString());
  return http.post(`${API_BASE_CONTENT}favourite_articles/`, data, {
    //headers: { "X-CSRFToken": getCSRFToken() },
  });
}
